import { action } from '@ember/object';
import { fadeIn, fadeOut } from 'ember-animated/motions/opacity';
import { isTest } from '../../../utils/is-testing';
import { service } from '@ember/service';
import { task, timeout as waiter } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import generateUUID from '../../../utils/generate-uuid';
import move from 'ember-animated/motions/move';
import styles from './container.module.scss';

const DEFAULT_TIMEOUT = 3000;

export default class SpdsToastContainer extends Component {
  isTest = isTest();
  styles = styles;

  @tracked toasts = [];

  @service alertManager;

  get event() {
    return this.args.local ? 'displayLocalToast' : 'displayToast';
  }

  constructor() {
    super(...arguments);

    this.#setupContainer();
  }

  #setupContainer() {
    let { alertManager, displayToast: handler, event } = this;

    alertManager.bindEventHandler({
      context: this,
      event,
      handler,
    });
  }

  *transition({ insertedSprites, keptSprites, removedSprites }) {
    let y = window.innerHeight;

    for (let sprite of insertedSprites) {
      sprite.startAtPixel({ y });
      fadeIn(sprite, { duration: 300, to: 1 });
      move(sprite);
    }

    keptSprites.forEach(move);

    for (let sprite of removedSprites) {
      sprite.endAtPixel({ y });
      fadeOut(sprite, { duration: 200, to: 0 });
      move(sprite);
    }
  }

  displayToast(toast) {
    this.toasts = [...this.toasts, { id: generateUUID(), ...toast }];

    if (this.running) return;

    this.manageTimer();
  }

  async manageTimer() {
    let toast = this.toasts[0];
    let { timeout = DEFAULT_TIMEOUT } = toast;

    if (timeout > 0 && !this.isTest) {
      this.enqueueToastDismissal.perform(toast, timeout);
    }
  }

  willDestroy() {
    super.willDestroy(...arguments);

    this.enqueueToastDismissal.cancelAll();
  }

  @(task(function* (toast, t) {
    this.running = true;
    yield waiter(t);
    this.autoDismiss(toast);
  }).enqueue())
  enqueueToastDismissal;

  @action
  autoDismiss(toast) {
    let index = this.toasts.findIndex(({ id }) => id === toast.id);

    this.toasts.splice(index, 1);
    this.toasts = [...this.toasts];

    if (index === 0 && this.toasts.length) {
      this.manageTimer();
    } else if (this.toasts.length === 0) {
      this.running = false;
    }
  }

  @action
  manualDismiss(toast) {
    toast?.onManualDismissal?.();

    this.autoDismiss(toast);
  }
}
